import { useNavigate } from 'react-router-dom'
import { safeNextPath } from '@/loaders/identity-verify-loader'
import { useQuerySearchParams } from './use-query-search-params'

/**
 * 本人確認のページから次へ進む行き先。
 *
 * `identity-verify-loader` が挟むときにクエリへ載せた `nextPath`（確認・決済のどちらか）へ戻る。
 * URL に載る値なので `safeNextPath` を通す。渡されていない・許していない値なら既定の行き先へ進む。
 * 日本在住・海外在住のフォーム、スキップの両方から使う。
 */
export const useIdentityVerifyNextPath = () => {
  const navigate = useNavigate()
  const { nextPath } = useQuerySearchParams<{ nextPath?: string }>()

  const goNext = () => {
    navigate(safeNextPath(nextPath))
  }

  return { goNext }
}
